import * as Yup from "yup";

export const CategoryMatrixFormConfig = [
  {
    formheader: "categorymatrixformlabels.header",
    fields: [
      {
        name: "incident_category",
        label: "categorymatrixformlabels.incidentcategory",
        type: "select",
        defaultselect: true,
        placeholder: "Select Category",
        options: [],
        col: 6,
      },
      {
        name: "severity",
        label: "categorymatrixformlabels.severity",
        type: "select",
        defaultselect: true,
        placeholder: "Select Severity",
        options: [
          { label: "Level 1 – Minor", value: "Level 1 – Minor" },
          { label: "Level 2 – Moderate", value: "Level 2 – Moderate" },
          { label: "Level 3 – Major", value: "Level 3 – Major" },
          { label: "Level 4 – Critical", value: "Level 4 – Critical" },
        ],
        col: 6,
        disabled: false,
      },
      {
        name: "sop_resource",
        label: "categorymatrixformlabels.resourcelist",
        type: "multi_select",
        options: [],
        col: 12,
      },
    ],
  },
];

export const categoryMatrixSchema = Yup.object().shape({
  incident_category: Yup.string().required("Incident Category is required"),
  severity: Yup.string().required("Severity is required"),
  resource_items: Yup.array().of(
    Yup.object().shape({
      resource_id: Yup.string().required(),
      quantity: Yup.number().required("Quantity is required").min(1, "Quantity must be at least 1"),
    })
  ).min(1, "At least one resource is required"),
});
